import { GridReadyEvent } from "@ag-grid-community/core";
import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BoxSize } from "app/model/entities/entity-model";
import { AgFns, GridOptionsExt } from "app/shared/ag-fns";
import { DialogBaseComponent } from "app/shared/dialog-base.component";
import { DomainBaseComponent, wrapBusy } from "app/shared/domain-base.component";
import { DomainService } from "app/shared/domain.service";
import { UniAgFns } from "@/shared/uni-ag-fns";
import { takeUntil } from "rxjs/operators";
import { EditBoxSizeDialogComponent } from "./edit-box-size-dialog.component";

@Component({
  selector: "app-box-size",
  templateUrl: "./box-size.component.html",
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class BoxSizeComponent extends DomainBaseComponent implements OnInit {
  boxSizeGridOptions: GridOptionsExt;
  selectedBoxSize: BoxSize;
  boxSizes: BoxSize[];

  constructor(protected domainService: DomainService, protected route: ActivatedRoute) {
    super(domainService);
    this.route.queryParamMap.pipe(takeUntil(this.onDestroy)).subscribe(() => {
      this.updateFromContext();
    });
  }

  async updateFromContext() {
    this.boxSizeGridOptions = AgFns.initGridOptions(this, {
      onGridReady: this.onBoxSizeGridReady,
      onRowSelected: AgFns.handleRowSelected((e: BoxSize) => (this.selectedBoxSize = e)),
    });

    this.boxSizes = await this.dbQueryService.getBoxSizes();
    this.isPageReady = true;
  }

  async canDeactivate() {
    const ok = await super.canDeactivate();
    if (!ok) return false;
    this.uow.clearEntities(BoxSize);
    return true;
  }

  onBoxSizeGridReady(event: GridReadyEvent) {
    const colDefs = [
      {
        ...AgFns.createButtonProps("", this.editBoxSize.bind(this), { label: "Edit" }),
        ...AgFns.fixWidth(80),
      },
      { headerName: "Name", field: "name", filter: "agTextColumnFilter", ...AgFns.flexWidth(180) },
      { headerName: "Length (in)", field: "length", ...AgFns.fixWidth(110), type: "numericColumn" },
      { headerName: "Width (in)", field: "width", ...AgFns.fixWidth(110), type: "numericColumn" },
      { headerName: "Height (in)", field: "height", ...AgFns.fixWidth(110), type: "numericColumn" },
      UniAgFns.getEntityDeleteColDef(this.onDelete.bind(this), { canDisplay: () => true }),
    ];
    AgFns.initGrid(event, colDefs, [{ colId: "name", sort: "asc" }]);
  }

  async editBoxSize(boxSize?: BoxSize) {
    const r = await DialogBaseComponent.open(EditBoxSizeDialogComponent, this, {
      boxSize: boxSize,
    });
    if (r) {
      this.boxSizes = await this.dbQueryService.getBoxSizes();
      AgFns.refreshGrid(this.boxSizeGridOptions, this.boxSizes);
    }
  }

  @wrapBusy
  async onDelete(boxSize: BoxSize) {
    const ok = await this.dialogService.yesNoDialog("Delete Box Size?", `Delete "${boxSize.name}"?`);
    if (!ok) return;

    boxSize.entityAspect.setDeleted();
    const sr = await this.dbSaveService.saveChanges();
    if (sr) {
      this.toastr.success("Box Size deleted");
      this.boxSizes = await this.dbQueryService.getBoxSizes();
      AgFns.refreshGrid(this.boxSizeGridOptions, this.boxSizes);
    }
  }
}
